<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout">
          <div class="md-layout-item md-size-95 mx-auto">
            <h2 class="black text-center text-primary">{{$t('Map')}}</h2>
            <Map />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import PageHeader from "./layout/PageHeader";
import Map from "./components/Landing/Map";

export default {
  components: { PageHeader, Map },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",

  data() {
    return {
      image: require("@/assets/img/conference/landing-bg.jpg") // header img
    };
  }
};
</script>